import { render } from "./IconsSvg.vue?vue&type=template&id=e2c07176&scoped=true"
import script from "./IconsSvg.vue?vue&type=script&lang=js"
export * from "./IconsSvg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c07176"]])

export default __exports__